import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 0c-.534 0-1.052.084-1.537.241a.75.75 0 1 0 .462 1.427Q7.433 1.501 8 1.5A3.49 3.49 0 0 1 11.5 5 3.49 3.49 0 0 1 8 8.5 3.49 3.49 0 0 1 4.5 5 .75.75 0 1 0 3 5c0 2.752 2.248 5 5 5s5-2.248 5-5-2.248-5-5-5M2.75 12C1.24 12 0 13.24 0 14.75c0 1.802 1.14 3.196 2.653 4.031S6.084 20 8 20s3.833-.384 5.347-1.219c1.445-.797 2.52-2.116 2.617-3.801a.8.8 0 0 0 .037-.23c0-1.51-1.24-2.75-2.75-2.75h-1.155a.751.751 0 1 0 0 1.5h1.155c.698 0 1.248.55 1.249 1.248v.002c0 1.198-.673 2.054-1.878 2.719S9.71 18.5 8 18.5s-3.417-.366-4.622-1.031S1.5 15.948 1.5 14.75c0-.7.55-1.25 1.25-1.25h5.9a.751.751 0 1 0 0-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }